import React, { useState, useEffect } from "react";
import "../../assets/css/common.css";
import { randomImageEndpoint, randomImageFolderAssets } from '../../assets/data/constants';
import { BibleOfTheDay } from '../../components/bible/BibleOfThDay';

export const HotNews = () => {
    const [photo, setPhoto] = useState(null);

    useEffect(() => {
        // Fetch the random image URL from the server
        const fetchImage = async () => {
            const mediaUrl = `${randomImageEndpoint}?folder=asset`;
            try {
                const response = await fetch(mediaUrl);
                if (response.ok) {
                    const fileName = await response.text();
                    setPhoto(`${randomImageFolderAssets}${fileName}`);
                } else {
                    console.error("Failed to fetch image");
                }
            } catch (error) {
                console.error("Error fetching the image:", error);
            }
        };

        fetchImage();
    }, []);

    return (
        <>
            <section className='text_container_light'>
                <div className='container_100'>
                    <div className='container boxItems'>
                        <div style={{ position: 'relative' }}>
                            {photo ? (
                                <img width='100%' src={photo} alt='Hot News' style={{ display: 'block' }} />
                            ) : (
                                <p>Loading image...</p>
                            )}
                            {photo && <BibleOfTheDay overlay />}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
